export type ToolHandoff = {
  tool: 'diagnostic-projet' | 'orientation-motorisation' | 'comparateur-cout-global';
  title: string;
  summary: string;
};

const storageKey = 'autosens-tool-handoff';

export const saveToolHandoff = (handoff: ToolHandoff) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(storageKey, JSON.stringify(handoff));
};

export const consumeToolHandoff = (): ToolHandoff | null => {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(storageKey);
  if (!value) return null;
  window.sessionStorage.removeItem(storageKey);
  try {
    const parsed = JSON.parse(value) as Partial<ToolHandoff>;
    if (!parsed.tool || !parsed.title || !parsed.summary) return null;
    return parsed as ToolHandoff;
  } catch {
    return null;
  }
};
